// extracted by mini-css-extract-plugin
module.exports = {"tags":"table-tags_tags__2xEeq","tagCircle":"table-tags_tagCircle__3R7-I"};